var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{class:{ 'alert--full-width': _vm.fullWidth },attrs:{"icon":_vm.icon,"type":_vm.variant,"text":""}},[_c('Typography',{class:[_vm.messageColor, { 'alert__message--left': _vm.fullWidth }],attrs:{"variant":"body-2"}},[_vm._v(" "+_vm._s(_vm.message)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }